import { Component, ViewChild } from '@angular/core';
import {Nav, Platform, Events, LoadingController} from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { LoginPage } from '../pages/login/login';
import { CustomersPage } from '../pages/customers/customers';
import { PayPage } from '../pages/pay/pay';
import { DaysPage } from '../pages/days/days';
import { IncidentsPage } from '../pages/incidents/incidents';
import { InventoryPage } from '../pages/inventory/inventory';
import { FoodsPage } from '../pages/foods/foods';
import { CancellationsPage } from '../pages/cancellations/cancellations';
import { RoutesPage } from '../pages/routes/routes';
import { HomePage } from '../pages/home/home';
import { ChangesPage } from '../pages/changes/changes';
import { Params } from '../pages/params';
import {Http} from "@angular/http";

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  rootPage: any = LoginPage;
  version;
  pages: Array<{title: string, component: any, icon:string}>;
  menu: Array<{title: string, component: any, icon:string}>;
  usuarios: Array<{title: string, component: any, icon:string}>;
  userData:any;
  constructor(public loadingCtrl: LoadingController, public platform: Platform, public statusBar: StatusBar, public splashScreen: SplashScreen,public events: Events, public http: Http) {
    this.initializeApp();
    localStorage.removeItem('firebase:previous_websocket_failure');
    // used for an example of ngFor and navigation
    this.http.get('assets/json/v.json').subscribe((r)=>{
      this.version = r.json().version;
    });

    this.userData = Params.USER_DATA;
    this.usuarios = [];
    this.menu = [];
    events.subscribe('user:loggedin', () => {
        let loading = this.loadingCtrl.create()
        loading.present();

        events.subscribe('foods:ready', () => {
          loading.dismiss();
        });

        this.usuarios = [];
        this.menu = [];
        let roles = this.userData.roles;
        //if(roles.indexOf("ACC")!=-1) this.usuarios.push({ title: 'Cuentas',component: AccountsPage,icon:'contacts' });
        if(roles.indexOf("GCUS")!=-1) this.usuarios.push({ title: 'Clientes',component: CustomersPage,icon:'people' });
        if(roles.indexOf("GCUS")!=-1) this.usuarios.push({ title: 'Transacciones',component: PayPage,icon:'card' });

        // if(roles.indexOf("CAN")!=-1) this.usuarios.push({ title: 'Suspender',component: CancellationsPage,icon:'alert' });
        if(roles.indexOf("INC")!=-1) this.usuarios.push({ title: 'Incidencias',component: IncidentsPage,icon:'call' });
        if(roles.indexOf("INC")!=-1) this.usuarios.push({ title: 'Solicitudes',component: ChangesPage,icon:'md-git-pull-request' });
        if(roles.indexOf("ROU")!=-1) this.usuarios.push({ title: 'Rutas',component: RoutesPage ,icon:'navigate' });

        if(roles.indexOf("FOO")!=-1) {
          this.menu.push({ title: 'Comidas',component: FoodsPage,icon:'cafe' });
          //this.menu.push({ title: 'Planes',component: PlansPage,icon:'clipboard' });
        }

        if(roles.indexOf("PLA")!=-1) {
          //this.menu.push({ title: 'Ingredientes',component: IngredientsPage,icon:'nutrition' });
          //this.menu.push({ title: 'Recetas',component: RecipesPage,icon:'flask' });
          this.menu.push({ title: 'Etiquetas', component: DaysPage,icon:'restaurant'});
          this.menu.push({ title: 'Inventario', component: InventoryPage, icon:'md-clipboard'});
          // this.menu.push({ title: 'Etiquetas1', component: MenusPage,icon:'restaurant'});
        }
    });

    this.pages = [
      { title: 'Salir', component: LoginPage,icon:'exit'}
    ];

  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  openHome(){
    this.nav.setRoot(HomePage);
  }
  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    if(page.title=="Salir"){
      this.nav.setRoot(page.component,{logout:true});
      return;
    }
    this.nav.setRoot(page.component);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts